import React, { useRef, useState } from "react";
import "./contact.css";
import { Link } from "react-router-dom";
import Navbar from "../Common/Navbar";
import emailjs from "emailjs-com";
import indiaFlag from "../../Assets/locations/india-flag.png";
import usaFlag from "../../Assets/locations/usa-flag.png";
import canadaFlag from "../../Assets/locations/canada-flag.png";
import Footer from "../Common/Footer";
import { toast } from "react-toastify";
import { APP_CONFIG } from "../../config/app.config";
import { commenIcon } from "../../data/CommenIcon";

const Contact = () => {
  const formRef = useRef();

  const [formSubmitted, setFormSubmitted] = useState(false);

  const validateForm = (formValues) => {
    const errors = {};
    for (const [key, value] of Object.entries(formValues)) {
      if (value?.trim() === "") {
        errors[key] = `${key} is required`;
      }
    }
    return errors;
  };

  const footerMenu = {
    id: 3,
    title: "Contact",
    list: [

      {
        listTitle: APP_CONFIG.email,
        path: APP_CONFIG.emailLink,
      },
      {
        listTitle: APP_CONFIG.phone,
        path: APP_CONFIG.phoneLink,
      },
    ],
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(formRef.current);
    const formValues = Object.fromEntries(formData.entries());
    let formValid = true;
    const errors = validateForm(formValues);
    if (Object.keys(errors).length > 0) {
      formValid = false;
    }

    if (formValid) {
      setFormSubmitted(true);
      const emailConfig = APP_CONFIG.emailJs;
      const { service, contact_template, publicKey } = emailConfig;
      emailjs
        .sendForm(service, contact_template, formRef.current, publicKey)
        .then(
          (result) => {
            console.log(result.text);
            toast.success("Message sent successfully!");
            formRef.current.reset();
            setFormSubmitted(false);
          },
          (error) => {
            console.log(error.text);
            toast.error("Failed to send the message, please try again.");
          }
        );
    } else {
      toast.warn("Please fill in all fields.");
    }
  };

  return (
    <>
      <div className="contact0_container">
        <div className="contact_bg">
          <Navbar />
          <div className="contact_head_container">
            
            <h1>Let's Start a Conversation</h1>
            <p className="contact_head_subtitle">
              Whether it's taxes, bookkeeping, or business advice, our team is just a message away.
            </p>
          </div>
        </div>
      </div>

      <div className="contact-container py-4 my-4">
        <div className="contact-info">
          <p className="heading">CONTACT</p>
          <h1>Get In Touch</h1>
          <p>
            Connect with us today for expert tax consulting services tailored to
            your needs. Our dedicated team is here to provide personalized
            solutions that ensure your financial goals are met with precision
            and peace of mind.
          </p>

          <div className="contact-details">
            <div className="business-hours">
              <h2>Business Hours</h2>
              <p>Monday - Thursday: 9:30am - 8:00pm</p>
              <p>Friday: 9:00am - 9:30pm</p>
              <p>Saturday: 8:30am - 10:30pm</p>
              <p>Sunday: 9:00am – 12:00pm</p>
            </div>
            <div className="contact-items">
              <div className="contact-item">
                <h2>Contact</h2>
                {footerMenu.list.map((footerList) => (
                  <p>
                    <Link
                      to={footerList.path}
                      key={footerList.listTitle}
                      target={footerList.type || ""}
                    >
                      {footerList.listTitle}
                    </Link>
                  </p>
                ))}
              </div>
              <div className="social-item">
                <h2>Follow Us</h2>
                <p>Stay connected with us on social media</p>
              </div>
              <div className="social-icons">
                {commenIcon.map((icon) => (
                  <Link key={icon.id} to={icon.path} target="_blank">
                    {icon.icon}
                  </Link>
                ))}
              </div>
            </div>


          </div>
        </div>
        <div className="contact-form">
          <h2>Send A Message</h2>
          <p>
            Use our contact form below to get started on optimizing your
            financial strategy with confidence.
          </p>
          <form ref={formRef} onSubmit={handleSubmit}>
            <input type="text" name="name" placeholder="Name" required />
            <input type="email" name="email" placeholder="Email" required />
            <select className="form-select" name="service" required>
              <option value="" disabled>
                Select a service
              </option>
              <option value="Tax Consulting">Tax Consulting</option>
              <option value="Bookkeeping Services">Bookkeeping Services</option>
              <option value="Taxes">Taxes</option>
              <option value="Business Registration">
                Business Registration
              </option>
              <option value="Loans & Mortgages">Loans & Mortgages</option>
              <option value="Rental Property HST Rebates">
                Rental Property HST Rebates
              </option>
              <option value="Auditing">Auditing</option>
              <option value="Payroll Management">Payroll Management</option>
              <option value="Tax Planning and Reporting">
                Tax Planning and Reporting
              </option>
              <option value="Legally Required">Legally Required</option>
              <option value="Strategic HR Consulting">Strategic HR Consulting</option>
              <option value="IT Services Partnering">IT Services Partnering</option>
              <option value="OrientalPay - Payroll">OrientalPay - Payroll</option>
              <option value="CRA fax service">CRA fax service</option>
            </select>
            <textarea name="message" placeholder="Message" required></textarea>
            <button disabled={formSubmitted} type="submit">
              Send Message
            </button>
          </form>
        </div>
      </div>
      <div className="location-container">
        <h2>Our Locations</h2>
        <p className="loc-subheading">Serving clients across Canada, the USA, and India.</p>
        <span className="loc-accent-line" />

        <div className="locations-flex">

          {/* Canada HQ */}
          <div className="location">
            <div className="location-logo">
              <img src={canadaFlag} alt="Canada Flag" className="flag-icon" />
              <h5>Canada HQ <span className="loc-hq-badge">HQ</span></h5>
            </div>
            <div className="location-divider" />
            <p>
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></svg>
              Corporate House, {APP_CONFIG.address}
            </p>
            <p>
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.8 19.79 19.79 0 01.22 1.18 2 2 0 012.22 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.91 7.09a16 16 0 006 6l.56-.56a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 14.92z"/></svg>
              <a href={APP_CONFIG.phoneLink}>{APP_CONFIG.phone}</a>
            </p>
            <p>
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
              <a href={APP_CONFIG.emailLink}>{APP_CONFIG.email}</a>
            </p>
          </div>

          {/* Brampton, Canada */}
          <div className="location">
            <div className="location-logo">
              <img src={canadaFlag} alt="Canada Flag" className="flag-icon" />
              <h5>Brampton, Canada</h5>
            </div>
            <div className="location-divider" />
            <p>
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></svg>
              80 Culture Cres, Brampton, ON, L6X 5A2
            </p>
            <p>
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
              <a href={APP_CONFIG.emailLink}>{APP_CONFIG.email}</a>
            </p>
          </div>

          {/* USA */}
          <div className="location">
            <div className="location-logo">
              <img src={usaFlag} alt="USA Flag" className="flag-icon" />
              <h5>USA</h5>
            </div>
            <div className="location-divider" />
            <p>
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></svg>
              1500 White Birch Ter Fremont, CA – 94536
            </p>
            <p>
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
              <a href={APP_CONFIG.emailLink}>{APP_CONFIG.email}</a>
            </p>
          </div>

          {/* India */}
          <div className="location">
            <div className="location-logo">
              <img src={indiaFlag} alt="India Flag" className="flag-icon" />
              <h5>India</h5>
            </div>
            <div className="location-divider" />
            <p>
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></svg>
              Oriental Business Solutions Pvt Ltd, 154 Shivani Palace, Revathipuram 4th Street, Urappakkam, Chennai 603210
            </p>
            <p>
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
              <a href={APP_CONFIG.emailLink}>{APP_CONFIG.email}</a>
            </p>
          </div>

        </div>

        {/* Google Map */}
        <iframe
          src={APP_CONFIG.gmapLink}
          width="100%"
          height="420"
           allowFullScreen=""
          loading="lazy"
          style={{ border: 0, borderRadius: '14px', display: 'block', maxWidth: '1280px', margin: '0 auto' }}
          referrerPolicy="no-referrer-when-downgrade"
          title="Google Map"
        ></iframe>
      </div>


      <Footer />
    </>
  );
};

export default Contact;